import WizardCard from "../../components/WizardCard"
import CaptionList from "../../components/CaptionList"

const GovtWizardYourPlanSummaryCard = () => (
  <WizardCard paddingSize="md-y">
    <div className="flex flex-col gap-6">
      <h1 className="text-3xl font-display font-medium leading-[124%] tracking-[0.6px]">
        Your Plan Summary
      </h1>

      <p className="text-base font-body leading-[140%] tracking-[0.32px]">
        Review your plan summary below. You will be able to access these
        documents from your Dashboard at any time. You will find:
      </p>

      <CaptionList
        list={[
          "Document to print for NRCS visit",
          "Summary of goals selected and stacks included",
          "Quiz questions & your answers",
          "Next Steps",
        ]}
      />
    </div>
  </WizardCard>
)

export default GovtWizardYourPlanSummaryCard
